import { pxToRem } from 'modules/spacing';
export const getSizeFromProps = (props) => pxToRem(props.$size * 4);
export const getPrimaryColorFromProps = (props) => props.$primaryColor;
export const getSrcFromProps = (props) => props.$src;
export const getAlignmentFromProps = (props) => props.$alignment;
